import { useQuery } from "@tanstack/react-query"

import { api } from "@/api"
import ENDPOINTS from "@/constants/endpoints"

export type PaymentMethod = {
  type: string
  description: string
}

type PaymentMethodsResponse = {
  paymentMethods: PaymentMethod[]
}

export const useSmartRoutingPaymentMethods = () => {
  return useQuery({
    queryKey: ["smart-routing-payment-methods"],
    queryFn: async () => {
      const { data } =
        await api.get<PaymentMethodsResponse>(
          ENDPOINTS.SMART_ROUTING_PAYMENT_METHODS
        )
      return data.paymentMethods || []
    },
    staleTime: 1000 * 60 * 60, // 1 hora
  })
}
